import { Sun, Moon, Desktop } from '@phosphor-icons/react';

const THEME_OPTIONS = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Desktop },
];

/**
 * AppearanceCard - Theme selection controls
 */
export default function AppearanceCard({ theme, onThemeChange }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Appearance</h3>
      </div>
      <div className="card-body">
        <div>
          <label className="label">Theme</label>
          <p className="text-sm mb-3" style={{ color: 'var(--color-text-muted)' }}>
            Choose how Mytineri looks to you.
          </p>
          <div className="flex gap-2">
            {THEME_OPTIONS.map((option) => {
              const Icon = option.icon;
              const isActive = theme === option.value;
              return (
                <button
                  key={option.value}
                  onClick={() => onThemeChange(option.value)}
                  className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-sm transition-all duration-200"
                  style={{
                    backgroundColor: isActive ? 'var(--color-accent-bg)' : 'var(--color-bg-raised)',
                    color: isActive ? 'white' : 'var(--color-text-secondary)',
                    border: `1px solid ${isActive ? 'var(--color-accent-border)' : 'var(--color-border-subtle)'}`,
                  }}
                >
                  <Icon size={18} weight={isActive ? 'fill' : 'regular'} />
                  <span className="text-sm font-medium">{option.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
